import { ACCORDION_FEATURES } from '@/constants/farmerSolutions'

import MobileSolutionItem from './MobileSolutionItem'

const MobileSolutionList = () => (
  <section className="md:hidden">
    {ACCORDION_FEATURES.map(({ heading, icon, description }) => (
      <MobileSolutionItem
        key={`mobile_${heading}`}
        heading={heading}
        icon={icon}
        description={description}
      />
    ))}
  </section>
)

export default MobileSolutionList
